export const FEET_TO_METERS = 3.28084;

export const METERS_TO_FEET = 1 / FEET_TO_METERS;

export const SPREADSHEET_RANGE_ROW = "1000";
export const SPREADSHEET_RANGE_COL = "Z";
